import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a6a8456"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "discountComponent" }
const _hoisted_2 = { class: "discountComponent__title" }
const _hoisted_3 = { class: "discountComponent__span" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, [
      _createTextVNode(" 🔸 "),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.discountMsg[_ctx.index][0].toUpperCase()), 1),
      _createTextVNode(" " + _toDisplayString(_ctx.discountMsg[_ctx.index][1].toUpperCase()) + " 🔸 ", 1)
    ])
  ]))
}